import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuthStore } from '@/features/auth';
import { ShellLayout } from '@/features/shell';

/**
 * Layout segmento `/app/*` — protegido por auth. `beforeLoad` redireciona
 * pra `/login` quando não autenticado.
 *
 * Filhos: definidos em `src/routes/app.*` (ex: `app.dashboard.tsx`).
 */
export const Route = createFileRoute('/app')({
  beforeLoad: () => {
    if (!useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
  component: ShellLayout,
});
